module.exports = __webpack_public_path__ + "img/4.a15fc149.jpg";